module.exports = __webpack_public_path__ + "static/media/997729.4031ef6b.jpg";